import { observer } from "mobx-react";
import * as React from "react";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkHeading, UitkParagraph } from "@egds/react-core/text";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { FlightsFlexModuleResult, FlightsLink } from "typings/microserviceModels/flights-flex-module";
import { TripType } from "components/flexComponents/Flights/util/typings";
import { withStores } from "stores";
import { FlightsStore } from "stores/FlightsStore";
import FlightsPill from "components/flexComponents/Flights/components/FlightsPill";
import FlightCards from "components/flexComponents/Flights/components/FlightCards";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

export interface FlightsViewProps {
  model: FlightsFlexModuleResult;
  id: string;
  flightsStore: FlightsStore;
  context: ExtendedContextStore;
}

export const FlightsView = withStores(
  "flightsStore",
  "context"
)(
  observer((props: FlightsViewProps) => {
    const { id, model, flightsStore } = props;
    const [flights, setFlights] = React.useState<FlightsLink[]>(
      model.flights.filter((f) => f.tripType === TripType.ROUND_TRIP)
    );
    const [tripTypePillToggleState, setTripTypePillToggleState] = React.useState<"roundTrip" | "oneWay" | "allDeals">(
      "roundTrip"
    );

    const filterOneWay = () => {
      setTripTypePillToggleState("oneWay");
      setFlights(
        model.flights.filter((flight) => {
          return flight.tripType === TripType.ONE_WAY;
        })
      );
    };
    const filterRoundTrip = () => {
      setTripTypePillToggleState("roundTrip");
      setFlights(
        model.flights.filter((flight) => {
          return flight.tripType === TripType.ROUND_TRIP;
        })
      );
    };
    const filterAllDeals = () => {
      setTripTypePillToggleState("allDeals");
      setFlights(model.flights);
    };
    const filterByMonth = (month: number) => {
      setFlights(
        model.flights.filter((flight) => {
          return flight.monthOfDeparture === month;
        })
      );
    };

    React.useEffect(() => {
      if (model.publishListingToMap) {
        flightsStore.publishFlightsToMap(flights);
      }
    }, flights);

    const flightsPillProps = {
      id,
      availableMonths: model.availableMonths,
      view: model.view,
      showMonthFilter: model.showMonthFilter,
      filterOneWay,
      filterAllDeals,
      filterRoundTrip,
      filterByMonth,
      tripTypePillToggleState,
    };

    const flightCardsProps = {
      view: model.view,
      useParentForAirportName: model.useParentForAirportName,
      flights: flights,
    };

    return (
      <>
        <UitkHeading tag="h2" size={5}>
          {props.model.title}
        </UitkHeading>
        <UitkSpacing padding={{ blockend: "two" }}>
          <UitkParagraph size={1}>{props.model.subtitle}</UitkParagraph>
        </UitkSpacing>
        <FlightsPill {...flightsPillProps} />
        <Viewport>
          <ViewLarge>
            <FlightCards isMobile={false} isTablet={false} {...flightCardsProps} />
          </ViewLarge>
          <ViewMedium>
            <FlightCards isMobile={false} isTablet={true} {...flightCardsProps} />
          </ViewMedium>
          <ViewSmall>
            <FlightCards isMobile={true} isTablet={false} {...flightCardsProps} />
          </ViewSmall>
        </Viewport>
      </>
    );
  })
);

export default FlightsView;
